<template>
  <div id="PaSchoolsMain">
    <div class="maxContainer">
      <keep-alive> <router-view></router-view></keep-alive>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return  {
        showFilter: false
      }
    },
    methods: {
    }
  }
</script>
<style scoped>
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Schools/PaSchoolsMain.vue